import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const theme = new URL(window.location.href).searchParams.get("theme");
const IS_DARK_THEME = theme === "dark";

const styles = theme => ({
  container: {
    backgroundColor: IS_DARK_THEME ? "#333333" : "#eceff1",
    padding: theme.spacing.unit,
    textAlign: "center"
  },
  wrapper: {
    marginTop: 10,
    display: "inline-block",
    borderRadius: 8,
    backgroundColor: "#ffffff"
  },
  item: {
    paddingBottom: 0
  }
});

class Intro extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isClosed: localStorage.getItem("READ_INTRO")
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    localStorage.setItem("READ_INTRO", true);
    this.setState({
      isClosed: true
    });
  }

  render() {
    const { classes } = this.props;
    const { isClosed } = this.state;
    if (isClosed) return null;

    return (
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <List dense>
            <ListItem className={classes.item}>
              <ListItemIcon>
                <Icon fontSize="small">chevron_right</Icon>
              </ListItemIcon>
              <Typography variant="body1">
                Sau khi đăng nhập bạn sẽ có một Team riêng, cập nhật ngay thông
                tin Team của bạn để kêu gọi mọi người cùng tham gia.
              </Typography>
            </ListItem>
            <ListItem className={classes.item}>
              <ListItemIcon>
                <Icon fontSize="small">chevron_right</Icon>
              </ListItemIcon>
              <Typography variant="body1">
                Nút <strong>Accept</strong> sẽ hiện dưới tên người muốn vào Team
                của bạn, nếu thấy phù hợp bạn có thể nhấn nút để gia nhập thành
                viên đó.
              </Typography>
            </ListItem>
            <ListItem className={classes.item}>
              <ListItemIcon>
                <Icon fontSize="small">chevron_right</Icon>
              </ListItemIcon>
              <Typography variant="body1">
                Khi chưa chung đội với ai, nếu thấy Team thú vị hãy nhấn ngay
                nút <strong>Team Up</strong> để xin tham gia.
                <strong>Team Up</strong> càng nhiều thì cơ hội càng cao nhé.
              </Typography>
            </ListItem>
            <ListItem className={classes.item}>
              <ListItemIcon>
                <Icon fontSize="small">chevron_right</Icon>
              </ListItemIcon>
              <Typography variant="body1">
                Và luôn nhớ thường xuyên truy cập app để cập nhật tình hình các
                Team, chúc bạn mau chóng tìm được đồng đội như ý!
              </Typography>
            </ListItem>
          </List>
          <IconButton onClick={this.handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Intro);
